import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3fcfd28&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"
import style0 from "./index.vue?vue&type=style&index=0&id=c3fcfd28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fcfd28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3fcfd28')) {
      api.createRecord('c3fcfd28', component.options)
    } else {
      api.reload('c3fcfd28', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3fcfd28&scoped=true&", function () {
      api.rerender('c3fcfd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/willingBlankRedirectPage/index.vue"
export default component.exports